import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tab", "content"];

  connect() {
    this.updateAll();
  }

  update(event) {
    const container = event.target.closest("[data-tab-id]");
    if (container) {
      this.updateTabForContainer(container.dataset.tabId);
    }
  }

  updateAll() {
    for (const content of this.contentTargets) {
      this.updateTabForContainer(content.dataset.tabId);
    };
  }

  updateTabForContainer(tabId) {
    // Find the content container and the associated tab by `tabId`
    const content = this.contentTargets.find(
      (content) => content.dataset.tabId === tabId
    );
    const tab = this.tabTargets.find((tab) => tab.dataset.tabId === tabId);

    if (content && tab) {
      const checkedCount = content.querySelectorAll("input[type='checkbox']:checked").length;
      const prefix = tab.dataset.prefix || "";

      tab.textContent = `${prefix} (${checkedCount})`;
    }
  }
}
